import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e9efcf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InventoryTMSFilters__holder" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "InventoryTMSFilters",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_select, {
        placeholder: "Лог. направление",
        value: _ctx.state.navigationIds,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.navigationIds) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.navigations.list,
        loading: _ctx.data_state.navigations.is_loading,
        failed: _ctx.data_state.navigations.is_failed,
        "error-text": "При получении списка направлений произошла ошибка",
        "can-deselect": "",
        multiselect: "",
        searchable: false,
        onRefresh: _ctx.loadNavigations
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Филиал",
        value: _ctx.state.warehouseIds,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.warehouseIds) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.warehouses.list,
        loading: _ctx.data_state.warehouses.is_loading,
        failed: _ctx.data_state.warehouses.is_failed,
        "error-text": "При получении списка филиалов произошла ошибка",
        label: "title",
        "can-deselect": "",
        multiselect: "",
        searchable: false,
        onRefresh: _ctx.loadWarehouses
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Контрагент",
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.companyId) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.companies.list,
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка контрагентов произошла ошибка",
        "infinite-scroll": "",
        "can-deselect": "",
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_new_select, {
        placeholder: "Тип перевозки",
        value: _ctx.state.transportTypeIds,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.transportTypeIds) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.data_state.transport_types.list,
        loading: _ctx.data_state.transport_types.is_loading,
        failed: _ctx.data_state.transport_types.is_failed,
        "error-text": "При получении списка типов перевозки произошла ошибка",
        "can-deselect": "",
        multiselect: "",
        onRefresh: _ctx.loadTransportTypes,
        searchable: false
      }, null, 8, ["value", "disabled", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_new_input, {
        placeholder: "Номер накладной",
        disabled: _ctx.disabled,
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.invoiceNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Номер заказа",
        disabled: _ctx.disabled,
        value: _ctx.state.orderNumber,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.orderNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        placeholder: "ВНГ",
        value: _ctx.state.isIntraCity,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.isIntraCity) = $event)),
        disabled: _ctx.disabled,
        options: _ctx.INTRA_OPTIONS,
        "can-deselect": "",
        "select-by": "value"
      }, null, 8, ["value", "disabled", "options"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search mr-3",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 32))
}